#include <fog_vertex>
vec4 comp = texture2D(positionTexture, reference);
displacement = comp.w;
vPos = comp.xyz;